// viewer.intent.js — click-vs-double-click disambiguation for map markers.
//
// Browsers expose no API for the OS double-click interval, so the window is
// a constant: 250 ms, matching CLICK_DBL_MS on the video surface
// (viewer.controls.js). The helper counts clicks itself rather than relying
// on the native dblclick event, so it behaves identically for mouse clicks
// and the click pairs Leaflet synthesizes from touch taps.

export function createClickIntent({ onSingle, onDouble, delayMs = 250 }) {
  let timer = null;

  function click() {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
      onDouble?.();
      return;
    }
    timer = setTimeout(() => {
      timer = null;
      onSingle?.();
    }, delayMs);
  }

  function cancel() {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  }

  return { click, cancel };
}
